import { render, staticRenderFns } from "./SVGAdminCategories.vue?vue&type=template&id=21e4df64&scoped=true&"
import script from "./SVGAdminCategories.vue?vue&type=script&lang=js&"
export * from "./SVGAdminCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e4df64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21e4df64')) {
      api.createRecord('21e4df64', component.options)
    } else {
      api.reload('21e4df64', component.options)
    }
    module.hot.accept("./SVGAdminCategories.vue?vue&type=template&id=21e4df64&scoped=true&", function () {
      api.rerender('21e4df64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGAdminCategories.vue"
export default component.exports